import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FlightSearch from "../components/Flight/FlightSearch"
import DefaultTemplate from "./DefaultTemplate"

const FlightSearchTemplate = (props) => {
   

    return (
        <DefaultTemplate>
            <FlightSearch />
            
        </DefaultTemplate>
    )
}

export default FlightSearchTemplate